import './chunk-851d1b8f.js';
import { merge } from './helpers.js';
import { c as config, a as setOptions } from './chunk-e92e3389.js';

var ConfigComponent = {
  getOptions: function getOptions() {
    return config;
  },
  setOptions: function setOptions$1(options) {
    setOptions(merge(config, options, true));
  }
};

export default ConfigComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/config.js
// module id = null
// module chunks = 